@if (inProgress) {
<mat-progress-bar 
         
          color="primary"
          mode="indeterminate">
</mat-progress-bar>
}
<form class="screen-video-upload-form" [formGroup]="uploadScreenVideoForm"  (ngSubmit)="uploadScreenVideo()">
    <mat-form-field class="field-full-width">
      <mat-label>Video Name</mat-label>
      <input matInput placeholder="Traing video name" formControlName="videoName">
    </mat-form-field>
    
    <mat-form-field class="field-full-width">
      <mat-label>Video Description</mat-label>
      <textarea matInput placeholder="Traing video description" formControlName="videoDescription"></textarea>
    </mat-form-field>
    
    <div class="field-full-width video-section" cellspacing="0">  
        <div>
            <button class="video-button" type="button" mat-raised-button 
                 (click)="videoFileInput.click()">
                    {{screenVideoFileName || 'Choose File'}}
            </button>
            
            <input style="display:none;" placeholder="Traing video name" (change)="onFileSelected()" 
                #videoFileInput type="file" id="file" accept="video/*" required>
            
            @if (screenVideoFileName) {
<section>
                <mat-slider min="1" step="1" 
                    [max]="selectedVideoDuration" 
                    discrete>
                    <input matSliderThumb
                        [value]="selectedTime"
                        (valueChange)="selectFrame($event)">
                </mat-slider>
                <span class="chooseThumbnail">Choose a thumbnail...</span>
            </section>
}
            <section class="is_client_specific">
                <mat-checkbox id="is_client_specific" formControlName="is_client_specific" color="primary">
                    Client Specific?
                </mat-checkbox>
                
            </section>
        </div>             
        @if (screenVideoFileName) {
<span class="poster-file" id="thumbnail">
            <img src="" #posterFile  width="200" height="125">
        </span>
}
    </div>

    <section class='upload-actions'>
        <button type="submit" class="upload_button" mat-raised-button color="primary" [disabled]="!uploadScreenVideoForm.valid" >
            Save
        </button>
        <button type="reset" class="reset_button" mat-raised-button color=""  (click)="resetUploadScreenVideoForm()" >
            Reset
        </button>
    </section>
    
</form>